import { useQuery } from 'react-query';
import apiCalls from '../../utils/apiCalls';

export function useBill({ billId }) {
  const { data, ...rest } = useQuery(
    ['bill', { billId }],
    () =>
      apiCalls
        .getBills({
          billId,
        })
        .then(({ data: { bills } }) => bills[0]),
    {
      enabled: !!billId,
    }
  );
  return { bill: data, ...rest };
}
